<template>
  <div>
    <div class="mx-3 mt-2 p-2 yd-balance" :style="{opacity: isDisabled ? 0.4 : 1}">
      <div class="d-flex align-items-center">
        <img src="@/assets/icon/saldo-yesdok-new.svg" alt="saldo yesdok">
        <div class="ml-2">
          <div style="font-size: 14px;">
            Saldo Yesdok
          </div>
          <div class="font-rubik-medium">
            Rp{{ saldoYesdok | formatMoney }}
          </div>
        </div>
      </div>
      <div style="z-index: 3;">
        <el-popover
          v-if="isDisabled"
          placement="bottom-end"
          width="390"
          trigger="hover"
          content="Saldo Yesdok tidak bisa digunakan, minimal transaksi tambahan Rp 10,000"
        >
          <img slot="reference" src="@/assets/icon/guard-warning.svg" width="25px" alt="warning" class="mr-2">
        </el-popover>
        <el-switch v-else :value="isYesdokBalance" active-color="#7E63F0" :disabled="isDisabled" @change="onChangeSaldoYesdok" />
      </div>
      <div class="bg-gradient-purple" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SaldoYesDok',
  props: {
    saldoYesdok: {
      type: Number,
      default: 0
    },
    isYesdokBalance: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showTolltip: false
  }),
  methods: {
    onChangeSaldoYesdok (value) {
      this.$emit('change-saldo-yesdok', value)
    }
  }
}
</script>

<style>
.yd-balance {
  color: #7E63F0;
  background-color: #F2ECFE;
  border: 1px solid #7E63F0;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.bg-gradient-purple {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(231.67deg, rgba(126, 99, 240, 0.45) -3.74%, rgba(126, 99, 240, 0) 76.72%);
}

</style>
